import { WREX_CORE } from '@lumapps/wrex/keys';

export const STRUCTURED_CONTENT_WREX_EDITOR_CLASSNAME = 'wrex-editor';

export const DEFAULT_STRUCTURED_CONTENT_PLACEHOLDER = WREX_CORE.EDITOR_WITH_MENTION_PLACEHOLDER;
